module.exports = __webpack_public_path__ + "img/thumbnail_WestAfricanLion_m_albino.d187578c.png";